import { API_ROUTES } from "../config/baseURL";
import request from "./clientsApi";
import { toast } from "react-toastify";

export const phoneAPI = {
  /** Obtener teléfonos */
  async getPhones(id) {
    try {
      const res = await request(API_ROUTES.getGeneralData("Phone", id), {
        method: "GET",
      });
      const data = await res.json();

      if (data?.success === false) {
        toast.error(data.message || "Ocurrió un error.");
        return [];
      }

      return data.data || [];
    } catch (err) {
      console.error("Error al cargar telefono:", err);
      return [];
    }
  },

  /** Guardar teléfono */
  async savePhone(payload) {
    const isUpdate = !!payload.id;
    const res = await request(API_ROUTES.savePhone, {
      method: isUpdate ? "PUT" : "POST",
      body: JSON.stringify(payload),
    });
    const data = await res.json();

    if (data?.success === false) {
      toast.error(data.message || "Ocurrió un error.");
      return false;
    }

    return data;
  },

  /** Inactivar teléfono */
  async inactivePhone(id) {
    try {
      const res = await request(API_ROUTES.updateGeneralData, {
        method: "PUT",
        body: JSON.stringify({ id, tipo: "Phone" }),
      });

      const data = await res.json();

      if (data?.success === false) {
        toast.error(data.message || "Ocurrió un error.");
        return false;
      }
      return true;
    } catch (err) {
      console.error("Error al eliminar dirección:", err);
      return false;
    }
  },

};
